<section class="breadcrumb-banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="breadcrumb-text">
                    <h1>Nagpur District Open & Women's Chess Championship 2026
                    </h1>
                </div>
            </div>
        </div>
    </div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png">
    </div>
</section>
<section class="section-lg">
    <div class="container">
        <div class="sec-title">
            <h2> <span>Nagpur District Open & Women's Chess Championship 2026</span>
            </h2>
        </div>
        <p><strong>Date:</strong> February 15, 2026</p>
        <p><strong>Venue:</strong> GH Raisoni College ,6th Floor, Moot Court Hall, Riaan Tower, Mangalwari, Nagpur</p>

        <p>The <strong>Nagpur District Open & Women's Chess Championship 2026</strong> was
            successfully organized on 1 <strong>5th February 2026 </strong>at<strong> GH Raisoni College,</strong> 6th
            Floor,
            Moot Court Hall, Riaan Tower, Mangalwari, Nagpur. </p>
        <p> The championship was organized by <strong>Chess Association Nagpur</strong>, in association with
            <strong> GH Raisoni Sports and Cultural Foundation and Kalpana Prakash Welfare
                Foundation.</strong>
        </p>
        <p>The event was organized separately for the Boys and Girls categories across different
            age groups, offering young chess talents a competitive platform to demonstrate their
            skills and qualify for the next level, the State-Level Chess Tournament.</p>
        <hr>
        <h5 class="primary-purple">Prize Money & Selection Details </h5>

        <ul class="list-style list-style1 mb-3  ">
            <li><strong> Cash Prize:</strong> ₹5,000 per category</li>
            <li><strong> Total Cash Prize Fund:</strong> ₹10,000</li>
            <li>Cash Prizes Top 5 & Trophies for Top 10 – Open & Women's</li>
            <li> Medals for Top 3 – S55,U19,U15,U11,U13, U-09 & U-07 (Boys & Girls
                separately)</li>
            <li><strong>Selection Criteria:
                </strong>
                <br><strong>Top 4 players from each category </strong>(Boys & Girls) were selected to
                represent <strong>State Level</strong> in the next stage of the championship.
            </li>
        </ul>
        <hr>
        <h5 class="primary-purple"> Dignitaries Present:</h5>
        <ul class="list-style list-style1 mb-3  ">
            <li><strong>C.A. Satish Girdharlal Sarda</strong>
                Managing Partner, Sarda Soni Associates LLP.
                Past Chairam of ICAI Nagpur & WICASA Nagpur
                Past President Orange City Jayceel.</li>
            <li><strong>Smt. Mamta Satish Sarda</strong> – Director (Admin),
                CIFC Private Limited and Director Safal Consultants.</li>
            <li><strong>Shri Bhushan Shriwas,</strong> Secretary Kalpana Prakash
                Welfare Foundation & Chess Association Nagpur</li>
            <li><strong>Shri S.S Soman</strong>
                Working President CAN</li>
            <li>IA Shiva Iyer
                Chief Arbiter</li>
        </ul>
        <hr>
        <h5 class="primary-purple"> Tournament Highlights:</h5>
        <ul class="list-style list-style1 mb-3 list-count ">
            <li>Format: Rapid, 8 Rounds, Swiss System</li>
            <li> Time Control: 10 mins + 05 sec increment per move</li>
            <li>Arbiter Team Lead by : IA Shiva Iyer (Chief Arbiter)</li>
        </ul>
        <hr>
        <h5 class="primary-purple"> Deputy & Supporting Arbiters:</h5>
        <ul class="list-style list-style1 mb-3 list-count ">
            <li>FA Amitkumar, Mukesh Tembhurne (Deputy Chief Arbiter)</li>
            <li>SNAAmbade, Prayas</li>
            <li>SNA Shrikant, Bagde</li>
            <li>SNA Shishir Indurkar</li>
        </ul>
        <hr>
        <h5 class="primary-purple"> Final Standing </h5>
        <div class="row">
            <div class="col">
                <ul class="list-style list-style1 mb-3  ">
                    <li> 1
                        st
                        . Thakur Aarit (Open)
                    </li>
                    <li> 2
                        nd
                        . Gupta Mayur A (Open)
                    </li>
                    <li> 3
                        rd
                        . Kushagra Paliwal (Open)
                    </li>
                    <li> 4
                        th
                        . Bhagchandani Mohak (Open)
                    </li>
                </ul>
            </div>
            <div class="col">
                <ul class="list-style list-style1 mb-3  ">
                    <li> 1
                        st
                        . Vritika Krushna Game (Women)
                    </li>
                    <li> 2
                        nd
                        . Mishrikotkar Vidhi (Women)
                    </li>
                    <li> 3
                        rd
                        . Junghare Avanti (Women)
                    </li>
                    <li> 4
                        th
                        . Khedkar Shambhavi (Women)
                    </li>
                </ul>
            </div>
        </div>
        <hr>
        <p>A group winner photo of the <strong>Nagpur District Open & Women's Chess Championship 2026</strong> was
            taken and preserved as a special memory of the event’s successful completion.
        </p>
        <p>The tournament was conducted smoothly, adhering to FIDE and AICF regulations.
            The response from players was overwhelming, and feedback has been highly
            positive. The Chief Arbiter appreciates the cooperation from the organizers, support
            staff, and the fair play spirit exhibited by all participants.</p>


        <div class="col-md-12">
            <div class="sec-title mt-4 text-center">
                <h2><span>Photo Gallery</span></h2>
            </div>
            <div class="lightBox--gallery">
                <ul class="list-unstyled lightgallery justify-content-center row row-cols-2 row-cols-md-3">
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-open-tournament/chess-open-tournament-1.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-open-tournament/chess-open-tournament-1.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-open-tournament/chess-open-tournament-1.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                            </div>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="gall-ery shadow-soft">
            <div class="row">
                <div class="col-md-8">
                    <div class="widget_title inner-title gall-sys">
                        <h4>Reports</h4>
                    </div>
                </div>
            </div>
            <div class="row row-cols-1 row-cols-lg-4">
                <div class="col">
                    <a href="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-open-tournament/doc-20260216-WA0012.pdf"
                        target="blank">
                        <div class="category-icon-title shadow-inset">
                            <div class="category-title"><span class="flaticon-pdf"></span>
                                <h4> Women Selection Chess Championship </h4>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col">
                    <a href="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-open-tournament/open-prize-list.pdf"
                        target="blank">
                        <div class="category-icon-title shadow-inset">
                            <div class="category-title"><span class="flaticon-pdf"></span>
                                <h4> Open Prize List </h4>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col">
                    <a href="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-open-tournament/open-women-prize-list.pdf"
                        target="blank">
                        <div class="category-icon-title shadow-inset">
                            <div class="category-title"><span class="flaticon-pdf"></span>
                                <h4> Open Women Prize List </h4>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col">
                    <a href="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-open-tournament/women-prize-list.pdf"
                        target="blank">
                        <div class="category-icon-title shadow-inset">
                            <div class="category-title"><span class="flaticon-pdf"></span>
                                <h4> Women Prize List </h4>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>

</section>
